module.exports = __webpack_public_path__ + "staticcomp/img/top.61675d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/9/top.jpg
// module id = JksZ
// module chunks = 39